module.exports = __webpack_public_path__ + "img/dashboard.557fd89d.png";